'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isThisYear;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isThisYear.js
// module id = 320
// module chunks = 0